export class PendingInvoiceSaleList {
  constructor(client, createdDt, foil, id, total) {
    this.client = client;
    this.createdDt = createdDt;
    this.foil = foil;
    this.id = id;
    this.total = total;
  }

  get autocompleteLabel() {
    return `${this.id} - $${this.total}  (${this.createdDt})`;
  }
}
